import { render, staticRenderFns } from "./XwzxView.vue?vue&type=template&id=2e2aa186&scoped=true&"
import script from "./XwzxView.vue?vue&type=script&lang=js&"
export * from "./XwzxView.vue?vue&type=script&lang=js&"
import style0 from "./XwzxView.vue?vue&type=style&index=0&id=2e2aa186&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2aa186",
  null
  
)

export default component.exports